/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="walkinManagerSettings.base.section.ts" />

module Meevo.Plugins.WalkinManagerSettings {
    "use strict";

    interface IValidationMessages {
        soonerMessage: string,
        laterMessage: string
    }

    /**
     * WalkIn Hours Section of Walkin Manager Settings
     */
    export class WalkInHoursSection extends Meevo.Plugins.WalkinManagerSettings.BaseSection {

        public fromTimeValidationMessages: IValidationMessages = {
            soonerMessage: 'Should start not earlier than business starts working',
            laterMessage: 'End Time must be greater than start time'
        };

        public toTimeValidationMessages: IValidationMessages = {
            soonerMessage: 'Should start not earlier than Walk-In start hours',
            laterMessage: 'Walk-in hours should not be configured past business hours'
        };

        /**
         * Handles retrieval of the item from the data service (if it hasn't already been loaded)
         * @returns {}
         */
        public activate(): void {

            if (this.model.walkInHours.length === 0 ||
                _.every(this.model.walkInHours, (day: any) => {
                return moment(day.startTime).isSame(moment(day.startTime).startOf('day')) &&
                    moment(day.endTime).isSame(moment(day.endTime).startOf('day'));
                })) {
                this.model.walkInHours = this.model.standardBusinessHours
                    .map(daySetup => angular.merge({}, daySetup, { isEnabled: false }));
            }
        }

        public onWalkinHourChanged(walkInHour, index): void {
            if (walkInHour.isEnabled) {
                if (!walkInHour.startTime || moment(walkInHour.startTime).isSame(moment(walkInHour.startTime).startOf('day'))) {
                    walkInHour.startTime = this.model.standardBusinessHours[index].startTime;
                }
                if (!walkInHour.endTime || moment(walkInHour.endTime).isSame(moment(walkInHour.endTime).startOf('day'))) {
                    walkInHour.endTime = this.model.standardBusinessHours[index].endTime;
                }
            }
        }
    }

}